export default __webpack_public_path__ + "static/RLC-e7b0df046b4dec2d41e53cd445cd3bf2.png";